export const SERVER_HOST = 'enx-cirion-78.enx.host:11000';
export const SERVER_DISPLAY_NAME = 'Nexus SMP';
export const STATUS_REFRESH_MS = 60_000;
